var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tabs',{attrs:{"value":"Language"}},_vm._l((_vm.activeValues),function(tab,i){return _c('tab-pane',{key:tab.language,attrs:{"title":_vm.labels(tab.language)}},[_vm._t("body",null,{"index":tab.index})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }